import { ProgressBarProps } from '@procore/core-react/dist/_typedoc/ProgressBar/ProgressBar.types.json';
import * as React from 'react';
export default {
  ProgressBarProps,
  React
};